import { ProcessGeneral } from 'api/endpoints/processes';
import BaseRepo from 'container/BaseRepo';
import { buildBadRequestApiError } from 'container/helpers/errors';
import { ApiResponseAsync, isApiError } from 'container/models';
import { SearchRequestTyped } from 'container/search';

import {
  DriverSettlementsProcessInstance,
  IDriverSettlementsAsyncProcessInstanceRepo,
} from './IDriverSettlementsAsyncProcessInstancesRepo';

export class DriverSettlementsAsyncProcessInstanceRepo
  extends BaseRepo
  implements IDriverSettlementsAsyncProcessInstanceRepo
{
  search = async (
    draft: ProcessGeneral,
    query: SearchRequestTyped<DriverSettlementsProcessInstance>
  ): ApiResponseAsync<Array<DriverSettlementsProcessInstance>> => {
    const link = draft._links?.['searchDriverSettlementsInstanceCreation'];

    if (!link) {
      return buildBadRequestApiError(
        new Error(
          'link "search Driver Settlements async process instances" is not available'
        )
      );
    }

    const searchResult = await this.helpers.executeSearch<
      DriverSettlementsProcessInstance[]
    >(link, query, { convertRequestToSnakeCase: true });
    if (isApiError(searchResult)) {
      return searchResult;
    }
    return searchResult ?? [];
  };
}
